/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const AudioQualityIssueDtoKindEnum = {
    silent: "silent",
    poor_quality: "poor_quality"
} as const;

export type AudioQualityIssueDtoKindEnumKey = (typeof AudioQualityIssueDtoKindEnum)[keyof typeof AudioQualityIssueDtoKindEnum];

export type AudioQualityIssueDto = {
    /**
     * @type string
    */
    stationId: string;
    /**
     * @type string
    */
    kind: AudioQualityIssueDtoKindEnumKey;
    /**
     * @type string
    */
    start: string;
    /**
     * @type string
    */
    end: string;
    /**
     * @type number
    */
    durationSeconds: number;
    /**
     * @type number
    */
    avgSilenceRatio: number | null;
    /**
     * @type number
    */
    avgQualityScore: number | null;
};